<template>
    <div class="footer">
        <div class="nav-link">
            <div class="footer-qr">
                <img src="@/assets/images/qr.png"/>
                <p class="p1">“全澜脑科学”</p>
                <p>公众号</p>
            </div>
          <div class="footer-sleep">
            <img src="@/assets/images/lm_sleep.png"/>
            <p class="p1">“澜猫睡眠”</p>
            <p>公众号</p>
          </div>
            <div class="footer-nav">
                <ul>
                    <li>
                        <ul>
                            <li class="nav-item"><a href="/">首页</a></li>
                            <li class="nav-item"><a href="/about">关于全澜</a></li>
                            <li class="nav-item"><a href="/news">新闻中心</a></li>
                            <li class="nav-item"><a href="/solution">解决方案</a></li>
                            <li class="nav-item"><a href="/support">服务支持</a></li>
                            <li class="nav-item"><a href="/contact">联系我们</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="footer-tab">
              <ul>
                <li>
                  <ul>
                    <li class="tab-item"><a href="javascript:void(0)">业务领域</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">公司简介</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">全澜动态</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">科研产品</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">技术支持</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">联系方式</a></li>
                  </ul>
                  <ul>
                    <li class="tab-item"><a href="javascript:void(0)">荣誉与资质</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">发展历程</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">产品动态</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">睡眠调控</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">下载中心</a></li>
                    <li class="tab-item"></li>
                  </ul>
                  <ul>
                    <li class="tab-item"></li>
                    <li class="tab-item"><a href="javascript:void(0)">合作单位</a></li>
                    <li class="tab-item"><a href="javascript:void(0)">最新活动</a></li>
                    <li class="tab-item"></li>
                    <li class="tab-item"></li>
                    <li class="tab-item"></li>
                  </ul>
                </li>
              </ul>
          </div>
          <div class="footer-info-group">
            <div class="footer-logo">
              <img src="@/assets/images/logo2@2x.png"/>
            </div>
            <div class="footer-phone">
              <div class="wrap">
                <img src="@/assets/images/phone.png"/>
                <span>+86&nbsp;19101672569</span>
              </div>
            </div>
            <div class="footer-email">
              <div class="wrap">
                <img src="@/assets/images/email.png"/>
                <span>sales@eegion.com</span>
              </div>
            </div>
            <div class="footer-address">
              <div class="wrap">
                <img src="@/assets/images/address.png"/>
                <span>上海市松江区强业路 801 号
                        G60 佘山智造园 4-3 号楼</span>
              </div>
            </div>
          </div>
        </div>
        <div class="split-line" style="margin-top: 100px;"></div>
        <div class="footer-bottom">
          <span>上海市全澜科技有限公司版权所有信息</span>
          <div>
            <span>沪公网安备：<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702890070" target="_blank">31011702890070号</a></span>
            <span>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2022031292号-9</a></span>
          </div>

        </div>
    </div>
</template>

<script>

  import { defineComponent } from 'vue';

  export default defineComponent({
    methods: {
      forwardTo(url) {
        window.location.href = url;
      }
    },
  });
</script>
<style  scoped  lang="scss">
    .footer {
        width: 100vw;
        min-width: 1440px;
        height: 420px;
        min-height: 340px;
        background-color: #232323 ;

      .footer-info-group {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 130px;
        height: 80px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 auto;
        position: absolute;
        top: 248px;
        padding-left: 28px;
      }
      .footer-logo {
        width: 138px;
        height: 46px;
        margin: 0;

        img {
          display: block;
        }
      }
      .footer-phone {
        width: 138px;
        height: 32px;
        margin-left: 80px;
        .wrap {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }
      .footer-email {
        width: 138px;
        height: 32px;
        .wrap {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }
      .footer-address {
        width: 230px;
        height: 32px;
        .wrap {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }

        .nav-link {
            position: relative;
            margin: 0px calc(50% - 650px);
            padding-top: 50px;
            width: 1200px;
            min-width: 1200px;
            height: 232px;

            :hover {
                background-color: transparent;
            }

            .footer-nav {
                position: absolute;
                flex: auto;
                width: 800px;
                height: 160px;

                /* 为 ul 应用样式，使其成为块级元素，并清除默认的列表样式 */
                ul {
                    width: 100%;
                    align-items: center;
                    list-style: none; /* 移除列表的默认标记 */
                    padding: 0; /* 移除默认的内边距 */
                    margin: 0; /* 移除默认的外边距 */
                    display: flex; /* 使用 Flexbox 布局 */
                    justify-content: space-between;

                    li {
                        flex: 1;
                        text-align: center;
                        // display: inline-block; /* 使 li 元素成为内联块级元素 */
                        // margin-right: 10px; /* 为 li 元素添加右边距，可根据需要调整 */
                        a {    
                            text-wrap: nowrap;
                            font-weight: 400;
                            list-style-type: disc;
                            text-decoration: none;
                            color:#ffffff;
                            font-size: 20px;
                        }
                    }

                    .nav-item {                        
                        line-height: 36px;
                    }
                }            
            }

          .footer-tab {
            position: absolute;
            top: 100px;
            flex: auto;
            width: 800px;
            height: 160px;

            /* 为 ul 应用样式，使其成为块级元素，并清除默认的列表样式 */
            ul {
              width: 100%;
              align-items: center;
              list-style: none; /* 移除列表的默认标记 */
              padding: 0; /* 移除默认的内边距 */
              margin: 0; /* 移除默认的外边距 */
              display: flex; /* 使用 Flexbox 布局 */
              justify-content: space-between;

              li {
                flex: 1;
                text-align: center;
                // display: inline-block; /* 使 li 元素成为内联块级元素 */
                // margin-right: 10px; /* 为 li 元素添加右边距，可根据需要调整 */
                a {
                  list-style-type: disc;
                  text-decoration: none;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 16px;
                  color: #B3B3B3;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
              }

              .tab-item {
                line-height: 36px;
              }
            }
          }

            .footer-qr {
                position: absolute;
                width: 98px;
                height: 158px;
                margin-top: 4px;
                margin-left: 1102px;

                p {
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 500;
                  font-size: 14px;
                  color: #979797;
                  text-align: center;
                  font-style: normal;
                  text-transform: none;
                  margin: 0;
                }

                .p1 {
                    margin-top: 20px;
                }
            }

          .footer-sleep {
            position: absolute;
            width: 98px;
            height: 158px;
            margin-top: 4px;
            margin-left: 1228px;

            p {
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #979797;
              text-align: center;
              font-style: normal;
              text-transform: none;
              margin: 0;
            }

            .p1 {
              margin-top: 20px;
            }
          }
        }
    }


    .footer-qr img, .footer-logo img {
        max-width: 100%;
        max-height: 100%;
    }

    .footer-bottom {
        width: 1326px;
        height:76px;
        padding: 10px 0px 10px 28px;
        background-color: transparent;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: rgba(255,255,255,0.6);
        text-align: justify;
        font-style: normal;
        text-transform: none;
        line-height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0px calc(50% - 650px);

    }
    .footer-bottom a {
        color: #FFFFFF;
        opacity: 0.8;
        text-decoration: none;
    }
</style>